<header class="app_header__container">
  <div class="app_header__content">
    <div class="app_header__content_brand">
      <a [routerLink]="'/'">
        <img
          src="../../../../assets/img/provart_logo.svg"
          alt="Provincia ART ML"
          srcset=""
        />
      </a>
    </div>
    <div class="app_header__content_loggedUser">

      <app-cx-header-tooltip loggedUser="{{loggedUser}}">
        <app-cx-header-tooltip-button
          link="/centro-de-ayuda"
          text="Centro de ayuda"
          icon="../../../../assets/icons/help_24px.svg">
        </app-cx-header-tooltip-button>

        <app-cx-header-tooltip-button
          (click)="logout()"
          link="/empresas"
          text="Cerrar Sesión"
          icon="../../../../assets/icons/exit_to_app_24px.svg">
        </app-cx-header-tooltip-button>

      </app-cx-header-tooltip>
    </div>
  </div>
</header>
